var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable react/require-default-props */
import { c } from '@/shared/utils/c';
export var MultiSelectButtons = function (_a) {
    var options = _a.options, selected = _a.selected, fullWith = _a.fullWith, onChange = _a.onChange;
    return (_jsx("div", __assign({ className: "btn-group btn-group-justified" }, { children: options.map(function (option) { return (_jsxs("button", __assign({ type: "button", className: c('btn btn-default', (selected === null || selected === void 0 ? void 0 : selected.includes(option.id)) && 'active'), onClick: function () {
                return onChange((selected === null || selected === void 0 ? void 0 : selected.includes(option.id))
                    ? selected === null || selected === void 0 ? void 0 : selected.filter(function (item) { return item !== option.id; })
                    : __spreadArray(__spreadArray([], (selected !== null && selected !== void 0 ? selected : []), true), [option.id], false));
            } }, { children: [option.icon && _jsx("span", __assign({ style: { marginRight: 5 } }, { children: option.icon })), option.label] }), option.id)); }) })));
};
